import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {HttpRequestCustomHeaderNames, HttpRequestCustomHeaderValues} from '../models/common.enums';
import {FileUploadService} from '@ui-app/components/file-upload/file-upload.service';
import {IFileUpload, IUploadUrlRequest, IUploadUrlResponse, PhotoData} from '@ui-app/models/common.models';

@Injectable()
export class S3UploadService extends FileUploadService implements IFileUpload {
    constructor(
        private httpClient: HttpClient,
    ) {
        super();
    }

    private readFile(file: File): Observable<ArrayBuffer | string> {
        const reader = new FileReader();

        return new Observable<ArrayBuffer | string>(
            (observer) => {
                reader.onloadend = () => {
                    let arrayBuffer: ArrayBuffer | string = reader.result;
                    observer.next(arrayBuffer);
                    arrayBuffer = null;
                };
                reader.readAsArrayBuffer(file);
            }
        );
    }

    private getS3UploadInfo(request: IUploadUrlRequest, uploadUrl: string): Observable<IUploadUrlResponse> {
        return this.httpClient.post<IUploadUrlResponse>(uploadUrl, request);
    }

    private uploadS3File(url: string, arrayBuffer: ArrayBuffer | string, headers: HttpHeaders): Observable<null> {
        return this.httpClient.put<null>(url, arrayBuffer, { headers });
    }

    uploadFile(file: File, uploadUrl: string): Observable<PhotoData> {
        let fileGuid: string;
        let arrayBuffer: ArrayBuffer | string;
        const request: IUploadUrlRequest = {
            name: file.name,
            contentType: file.type,
            length: file.size,
        };

        return this.readFile(file)
            .pipe(
                switchMap((fileBuffer: ArrayBuffer | string) => {
                    arrayBuffer = fileBuffer;
                    return this.getS3UploadInfo(request, uploadUrl);
                }),
                switchMap((uploadInfo: IUploadUrlResponse) => {
                    const { url, uId, headersToSet } = uploadInfo;
                    fileGuid = uId;
                    const headers: HttpHeaders = new HttpHeaders({
                        'Content-Type': file.type,
                        [HttpRequestCustomHeaderNames.DisableLoader]: HttpRequestCustomHeaderValues.LoaderDisabled,
                        ...headersToSet
                    });

                    return this.uploadS3File(url, arrayBuffer, headers);
                }),
                map(() => ({ uId: fileGuid, ...request })),
            );
    }
}
